module.exports = __webpack_public_path__ + "img/supervisor-intro-one.5a010dac.png";